import React from "react";

import {Route, Routes} from "react-router-dom";
import Activity from "./activity";
import OAuthInit from "./oauth/Init";
import GraphQLProvider from "../graphql/GraphQLProvider";
import OAuthCallback from "./oauth/Callback";
import Provider from "./oauth/Provider";

export default function QQCatalyst() {

    // TODO: Check QQCatalyst OAuth
    return <GraphQLProvider>
        <Provider>
            <Routes>
                <Route index element={<Activity />} />
                <Route path="oauth/init" element={<OAuthInit />} />
                <Route path="oauth/callback" element={<OAuthCallback />} />
            </Routes>
        </Provider>
    </GraphQLProvider>

}
